import { put, delay } from 'redux-saga/effects';
import { changeAuctionBet } from '../../../reducers';

export function* delayInputAuctionBet() {
  yield delay(400);

  yield put(changeAuctionBet());
}
